import { inAppPath } from "./inAppPath";

/**
 * Public v3 (P2.5): after signing in, go back to the page the person wanted. Strictly in-app: the value passes `inAppPath`, uses
 * only plain address characters, and never points at a public / sign-in / registration / onboarding page (those would be a loop or
 * "a mess"). Kept per tab in sessionStorage, for an hour, and read back once. It is checked again when read.
 */
const KEY = "cy_wanted_page";
const MAX_AGE_MS = 60 * 60 * 1000;
const PLAIN = /^\/[A-Za-z0-9\-._~%/?=&#+,:@]*$/;
const NEVER = /^\/(login|registration|forgot-password|reset-password|unAuthPage|onboarding)(?:[/?#]|$)/i;

export const wantedPathOrNull = (value: string | null | undefined): string | null => {
  const path = inAppPath(value);
  if (!path || path === "/" || !PLAIN.test(path) || NEVER.test(path) || path.startsWith("/?")) return null;
  return path;
};

export const rememberWantedPage = (value: string | null | undefined): void => {
  const path = wantedPathOrNull(value);
  if (!path) return;
  try { sessionStorage.setItem(KEY, JSON.stringify({ path, at: Date.now() })); } catch { /* storage blocked: the default page applies */ }
};

export const takeWantedPage = (): string | null => {
  try {
    const raw = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    if (!raw) return null;
    const { path, at } = JSON.parse(raw);
    if (typeof at !== "number" || Date.now() - at > MAX_AGE_MS) return null;
    return wantedPathOrNull(path);
  } catch { return null; }
};
